import { setLocalePath } from "@/locales/index";
export const locale_file_path = "views.worker_notice.";
/**
 * 언어팩 경로 셋팅 메서드
 * @param appendPath 추가로 붙일 경로 문자열
 * @returns
 */
export const autoLcWorkerNotice = (appendPath = "") => setLocalePath(locale_file_path + appendPath);
export default {
    edit: "@:{'common.edit'}",
    delete: "@:{'common.delete'}",
    back_to_list: "@:{'common.back_to_list'}",
    list: {
        page_title: "라이더 공지사항",
        description: "바로고 라이더님께 알려드립니다.",
        create: "라이더 공지사항 등록",
        table: {
            id: "번호",
            title: "제목",
            author: "작성자",
            created_time: "등록일",
            edit: "수정",
        },
    },
    form: {
        page_title: "등록 / 수정",
        create: "등록",
    },
    detail: {
        page_title: "상세보기",
        user_name: "작성자",
        period: "기간",
        endless: "전체",
        target_worker: "대상",
        target_dist_all_worker: "전체 허브 라이더",
        target_hub_all_worker: "허브 전체 라이더",
    },
    delete_alert: {
        head: "라이더 공지사항 삭제",
        body: "해당 글을 삭제 하시겠습니까?",
        body_with_id: "{id}번 공지사항을 삭제 하시겠습니까?",
    },
};
